var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mark-line" },
    _vm._l(_vm.lines, function (line) {
      return _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.lineStatus[line] || false,
            expression: "lineStatus[line] || false",
          },
        ],
        key: line,
        ref: line,
        refInFor: true,
        staticClass: "line",
        class: line.includes("x") ? "xline" : "yline",
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }